// ============================================
// PHONE FLAG SELECTOR (ВЫБОР КОДА СТРАНЫ ДЛЯ ТЕЛЕФОНА)
// ============================================

const PHONE_FLAG_ICON_PATHS = {
  ru: '/landing_2025/src/icon/rus.svg',
  uz: '/landing_2025/src/icon/uzb.svg',
};

function resolveCountryFlagEmoji(countryCode) {
  if (!countryCode) return '';

  if (typeof window.getCountryFlagEmoji === 'function') {
    const emoji = window.getCountryFlagEmoji(countryCode);
    if (emoji) return emoji;
  }

  try {
    const codePoints = String(countryCode)
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  } catch (_e) {
    return '';
  }
}

function countryFlagMarkup(countryCode) {
  const iso = String(countryCode || '').toLowerCase();
  const iconPath = PHONE_FLAG_ICON_PATHS[iso];

  if (iconPath) {
    return `<img class="phone-flag-icon phoneFlagImg flag-emoji" src="${iconPath}" alt="" width="22" height="22" data-country="${iso}" aria-hidden="true" />`;
  }

  return `<span class="flag-emoji" aria-hidden="true">${resolveCountryFlagEmoji(iso)}</span>`;
}

function renderPhoneFlagIcon(flagElement, countryCode) {
  if (!flagElement) return null;

  const iso = String(countryCode || '').toLowerCase();
  const iconPath = PHONE_FLAG_ICON_PATHS[iso];

  if (iconPath) {
    let img = flagElement;

    if (flagElement.tagName !== 'IMG') {
      img = document.createElement('img');
      img.id = flagElement.id;
      img.className = 'phone-flag-icon phoneFlagImg flag-emoji';
      img.alt = '';
      img.width = 22;
      img.height = 22;
      flagElement.parentNode.replaceChild(img, flagElement);
    }

    img.src = iconPath;
    img.dataset.country = iso;
    return img;
  }

  const emojiFlag = resolveCountryFlagEmoji(countryCode);
  if (!emojiFlag) return flagElement;

  if (flagElement.tagName === 'SPAN') {
    flagElement.classList.add('flag-emoji', 'phoneFlagImg');
    flagElement.dataset.country = iso;
    flagElement.textContent = emojiFlag;
    return flagElement;
  }

  const parent = flagElement.parentNode;
  if (!parent) return flagElement;

  const emojiSpan = document.createElement('span');
  emojiSpan.className = 'flag-emoji phoneFlagImg';
  emojiSpan.textContent = emojiFlag;
  emojiSpan.id = flagElement.id;
  emojiSpan.dataset.country = iso;
  parent.replaceChild(emojiSpan, flagElement);
  return emojiSpan;
}

function findCountryByPhoneCode(code) {
  if (!code || !window.countryCodesData) return null;
  return window.countryCodesData.find((item) => item.code === String(code).trim()) || null;
}

function ensureEmojiFlagElement(flagImgId, countryCode, existingElement) {
  const flagElement = existingElement || document.getElementById(flagImgId);
  if (!flagElement) return null;
  return renderPhoneFlagIcon(flagElement, countryCode);
}

// Функция для обеспечения наличия кнопки закрытия в заголовке модального окна
function ensureCloseButtonInHeader(phoneModal) {
  if (!phoneModal) return null;
  
  const phoneModalHeader = phoneModal.querySelector(".phone_modal_header");
  if (!phoneModalHeader) return null;
  
  let phoneCloseBtn = phoneModalHeader.querySelector(".phone_close_btn");
  
  // Если кнопки нет в заголовке, ищем её в других местах
  if (!phoneCloseBtn) {
    phoneCloseBtn = phoneModal.querySelector(".phone_close_btn");
    if (phoneCloseBtn) {
      // Перемещаем кнопку в заголовок
      phoneCloseBtn.remove();
      phoneModalHeader.appendChild(phoneCloseBtn);
    } else {
      // Создаем кнопку закрытия, если её нет
      phoneCloseBtn = document.createElement('button');
      phoneCloseBtn.className = 'phone_close_btn';
      phoneCloseBtn.innerHTML = '×';
      phoneModalHeader.appendChild(phoneCloseBtn);
    }
  }
  
  // Убираем кнопку закрытия из контейнера опций, если она там есть
  const phoneCountryOptionsContainer = phoneModal.querySelector(".phone_country_options");
  if (phoneCountryOptionsContainer) {
    const closeBtnInOptions = phoneCountryOptionsContainer.querySelector(".phone_close_btn");
    if (closeBtnInOptions) {
      closeBtnInOptions.remove();
    }
  }
  
  // Привязываем обработчик событий к кнопке, если его еще нет
  if (phoneCloseBtn && !phoneCloseBtn.dataset.handlerAttached) {
    phoneCloseBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      // Закрываем модальное окно
      phoneModal.classList.remove("open");
      // Находим соответствующий селектор и закрываем его
      const modalWrapper = phoneModal.closest('.phone_modal_wrapper');
      if (modalWrapper) {
        const selector = modalWrapper.parentElement?.querySelector('.phone_flag_selector');
        if (selector) {
          selector.classList.remove("active");
        }
      }
      // Также пробуем найти селектор через ID
      const modalId = phoneModal.id;
      if (modalId) {
        // Для phoneModal ищем phoneFlagSelector
        if (modalId === 'phoneModal') {
          const selector = document.getElementById('phoneFlagSelector');
          if (selector) selector.classList.remove("active");
        } else if (modalId === 'phoneModal2') {
          const selector = document.getElementById('phoneFlagSelector2');
          if (selector) selector.classList.remove("active");
        } else if (modalId === 'phoneModalBlock7') {
          const selector = document.getElementById('phoneFlagSelectorBlock7');
          if (selector) selector.classList.remove("active");
        } else if (modalId === 'phoneModal3') {
          const selector = document.getElementById('phoneFlagSelector3');
          if (selector) selector.classList.remove("active");
        } else if (modalId === 'phoneModal4') {
          const selector = document.getElementById('phoneFlagSelector4');
          if (selector) selector.classList.remove("active");
        } else if (modalId.includes('phoneModal_step2')) {
          // Для Step2 форм (числовые: step2_1, step2_2 и т.д., а также trial_day)
          const stepNum = modalId.match(/phoneModal_step2_(\d+)/)?.[1];
          const stepTrialDay = modalId === 'phoneModal_step2_trial_day' ? 'trial_day' : null;
          if (stepNum) {
            const selector = document.getElementById(`phoneFlagSelector_step2_${stepNum}`);
            if (selector) selector.classList.remove("active");
          } else if (stepTrialDay) {
            const selector = document.getElementById('phoneFlagSelector_step2_trial_day');
            if (selector) selector.classList.remove("active");
          }
        } else if (modalId === 'phoneModal_trial_day') {
          const selector = document.getElementById('phoneFlagSelector_trial_day');
          if (selector) selector.classList.remove("active");
        }
      }
    });
    phoneCloseBtn.dataset.handlerAttached = 'true';
  }
  
  return phoneCloseBtn;
}

// Универсальная функция для инициализации Phone Flag Selector
function initPhoneFlagSelector(config) {
  const {
    selectorId,
    modalId,
    flagImgId,
    codeId,
    commentId = null,
    commentSelector = null,
    onCountryChange = null
  } = config;

  const phoneFlagSelector = document.getElementById(selectorId);
  const phoneModal = document.getElementById(modalId);
  const phoneFlagImg = document.getElementById(flagImgId);
  const phoneCode = document.getElementById(codeId);

  if (!phoneFlagSelector || !phoneModal) return;

  // Проверяем, не инициализирован ли уже
  if (phoneFlagSelector.dataset.initialized === 'true') {
    return;
  }

  // Генерируем список стран динамически, если он еще не создан
  const phoneCountryOptionsContainer = phoneModal.querySelector(".phone_country_options");
  
  // Убеждаемся, что кнопка закрытия всегда есть в заголовке
  const phoneCloseBtn = ensureCloseButtonInHeader(phoneModal);
  
  // Проверяем количество существующих опций стран (не считая кнопку закрытия)
  const existingOptions = phoneCountryOptionsContainer ? phoneCountryOptionsContainer.querySelectorAll(".phone_country_option") : [];
  
  // Проверяем, нужно ли генерировать список стран (если меньше 10 стран, значит нужно добавить все)
  if (phoneCountryOptionsContainer && window.countryCodesData && existingOptions.length < 10) {
    phoneCountryOptionsContainer.innerHTML = '';
    
    // Генерируем опции для всех стран
    window.countryCodesData.forEach(country => {
      const option = document.createElement('div');
      option.className = 'phone_country_option';
      option.setAttribute('data-country', country.country);
      option.setAttribute('data-code', country.code);
      option.setAttribute('data-flag', 'emoji');
      option.setAttribute('data-placeholder', country.placeholder);
      option.innerHTML = `
        ${countryFlagMarkup(country.country)}
        <span>${country.code}</span>
      `;
      phoneCountryOptionsContainer.appendChild(option);
    });
  }

  const phoneCountryOptions = phoneModal.querySelectorAll(".phone_country_option");
  const phoneModalHeader = phoneModal.querySelector(".phone_modal_header");
  
  // Получаем кнопку закрытия из заголовка (она должна быть там после предыдущего кода)
  const phoneCloseBtnNew = phoneCloseBtn || (phoneModalHeader ? phoneModalHeader.querySelector(".phone_close_btn") : null);

  // Помечаем как инициализированный
  phoneFlagSelector.dataset.initialized = 'true';

  function openPhoneModal() {
    phoneModal.classList.add("open");
    phoneFlagSelector.classList.add("active");
  }

  function closePhoneModal() {
    phoneModal.classList.remove("open");
    phoneFlagSelector.classList.remove("active");
  }

  phoneFlagSelector.addEventListener("click", (e) => {
    // Проверяем, что клик не на phone_modal_wrapper или его дочерних элементах
    const phoneModalWrapper = phoneFlagSelector.querySelector('.phone_modal_wrapper');
    if (phoneModalWrapper && (phoneModalWrapper.contains(e.target) || e.target === phoneModalWrapper)) {
      return;
    }

    // Проверяем, что клик не на comment или его родительских элементах
    let comment = null;
    if (commentId) {
      comment = document.getElementById(commentId);
    } else if (commentSelector) {
      // Ищем comment в той же форме, что и phoneFlagSelector
      const form = phoneFlagSelector.closest(commentSelector);
      if (form) {
        comment = form.querySelector('input[type="text"].comment, input.comment');
      }
    }

    if (comment && (comment.contains(e.target) || e.target === comment || e.target.closest('.input_column_right'))) {
      return;
    }

    e.stopPropagation();
    if (commentSelector) {
      e.preventDefault();
    }
    phoneModal.classList.toggle("open");
    phoneFlagSelector.classList.toggle("active");
  });

  // Используем делегирование событий для работы с динамически созданными элементами
  if (phoneCountryOptionsContainer && !phoneCountryOptionsContainer.dataset.clickHandlerAttached) {
    phoneCountryOptionsContainer.addEventListener("click", (e) => {
      const option = e.target.closest(".phone_country_option");
      if (!option) return;
      
      e.stopPropagation();
      // Проверяем, что клик не на кнопке закрытия
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        return;
      }

      const country = option.dataset.country;
      const code = option.dataset.code;
      const placeholder = option.dataset.placeholder || '';

      renderPhoneFlagIcon(document.getElementById(flagImgId), country);
      phoneFlagSelector.dataset.selectedIso = country;
      if (phoneCode) phoneCode.textContent = code;

      // Очищаем поле телефона при смене кода страны и обновляем placeholder
      const phoneInput = phoneCode.closest('.phone_wrapper')?.querySelector('input[type="tel"]');
      if (phoneInput) {
        phoneInput.value = '';
        if (placeholder) {
          phoneInput.placeholder = placeholder;
        }
        // Сохраняем код страны в data-атрибут для валидации
        phoneInput.dataset.countryCode = code;
      }

      closePhoneModal();

      // Обновляем ограничения для этого поля телефона
      const curCountry = document.getElementById('curCountry');
      const currentRegion = curCountry ? curCountry.textContent : 'Россия';
      const phoneWrapper = phoneCode && phoneCode.closest('.phone_wrapper');
      if (typeof window.updatePhoneInputsLimits === 'function') {
        window.updatePhoneInputsLimits(currentRegion, phoneWrapper || null);
      }

      // Вызываем callback, если он предоставлен
      if (onCountryChange && typeof onCountryChange === 'function') {
        onCountryChange(country, code, 'emoji');
      }
    });
    phoneCountryOptionsContainer.dataset.clickHandlerAttached = 'true';
  }

  // Используем делегирование событий для кнопки закрытия (работает с динамически созданными кнопками)
  if (phoneModalHeader && !phoneModalHeader.dataset.closeHandlerAttached) {
    phoneModalHeader.addEventListener("click", (e) => {
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        e.stopPropagation();
        e.preventDefault();
        closePhoneModal();
      }
    });
    phoneModalHeader.dataset.closeHandlerAttached = 'true';
  }
  
  // Также привязываем обработчик напрямую к существующей кнопке
  if (phoneCloseBtnNew && !phoneCloseBtnNew.dataset.handlerAttached) {
    phoneCloseBtnNew.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      closePhoneModal();
    });
    phoneCloseBtnNew.dataset.handlerAttached = 'true';
  }
  
  // Добавляем валидацию для поля телефона
  const phoneInput = phoneCode?.closest('.phone_wrapper')?.querySelector('input[type="tel"]');
  if (phoneInput && typeof window.validatePhoneNumber === 'function') {
    phoneInput.addEventListener('blur', function() {
      const countryCode = this.dataset.countryCode || phoneCode?.textContent;
      if (countryCode && this.value.trim()) {
        const validation = window.validatePhoneNumber(this.value, countryCode);
        if (!validation.valid) {
          this.setCustomValidity(validation.message);
          this.reportValidity();
        } else {
          this.setCustomValidity('');
        }
      }
    });
    
    phoneInput.addEventListener('input', function() {
      // Очищаем ошибку при вводе
      if (this.validity.customError) {
        this.setCustomValidity('');
      }
    });
  }

  // Приводим отображаемый флаг к emoji сразу при инициализации.
  const initialCountryIso =
    phoneFlagSelector.dataset.selectedIso ||
    (findCountryByPhoneCode(phoneCode?.textContent || '') || {}).country ||
    "ru";
  renderPhoneFlagIcon(phoneFlagImg, initialCountryIso);
  phoneFlagSelector.dataset.selectedIso = initialCountryIso;

  // Обработчик клика вне селектора для закрытия модального окна
  const clickHandler = (e) => {
    if (!phoneFlagSelector.contains(e.target) && !phoneModal.contains(e.target)) {
      closePhoneModal();
    }
  };

  // Добавляем обработчик с небольшой задержкой для Step2 форм
  if (commentSelector) {
    setTimeout(() => {
      document.addEventListener("click", clickHandler);
    }, 100);
  } else {
    document.addEventListener("click", clickHandler);
  }
}

// Инициализация основного Phone Flag Selector
function _initMainPhoneSelectors() {
  function initMain() {
    initPhoneFlagSelector({
      selectorId: "phoneFlagSelector",
      modalId: "phoneModal",
      flagImgId: "phoneFlagImg",
      codeId: "phoneCode",
      commentId: "comment"
    });
    const phoneModal = document.getElementById("phoneModal");
    if (phoneModal && typeof window.ensureCloseButtonInHeader === 'function') {
      window.ensureCloseButtonInHeader(phoneModal);
    }
  }

  function initBlock11() {
    initPhoneFlagSelector({
      selectorId: "phoneFlagSelector2",
      modalId: "phoneModal2",
      flagImgId: "phoneFlagImg2",
      codeId: "phoneCode2",
      commentId: "comment2"
    });
    const phoneModal2 = document.getElementById("phoneModal2");
    if (phoneModal2 && typeof window.ensureCloseButtonInHeader === 'function') {
      window.ensureCloseButtonInHeader(phoneModal2);
    }
  }

  function initConsultation() {
    initPhoneFlagSelector({
      selectorId: "phoneFlagSelector3",
      modalId: "phoneModal3",
      flagImgId: "phoneFlagImg3",
      codeId: "phoneCode3",
      commentId: "comment3"
    });
    const phoneModal3 = document.getElementById("phoneModal3");
    if (phoneModal3 && typeof window.ensureCloseButtonInHeader === 'function') {
      window.ensureCloseButtonInHeader(phoneModal3);
    }
  }

  if (!window.countryCodesData) {
    setTimeout(() => { initMain(); initBlock11(); initConsultation(); }, 100);
  } else {
    initMain();
    initBlock11();
    initConsultation();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", _initMainPhoneSelectors);
} else {
  _initMainPhoneSelectors();
}

// Функция для инициализации Phone Flag Selector для Step2 форм
function initPhoneFlagSelectorStep2(selectorId, modalId, flagImgId, codeId) {
  const sourceSelectorId = selectorId.replace(/^phoneFlagSelector_step2_/, 'phoneFlagSelector_');
  const sourceCodeId = codeId.replace(/^phoneCode_step2_/, 'phoneCode_');
  const sourceFlagId = flagImgId.replace(/^phoneFlagImg_step2_/, 'phoneFlagImg_');
  const sourceSelector = document.getElementById(sourceSelectorId);
  const sourceCode = document.getElementById(sourceCodeId);
  const sourceFlag = document.getElementById(sourceFlagId);
  const targetSelector = document.getElementById(selectorId);
  const targetCode = document.getElementById(codeId);
  const targetFlag = document.getElementById(flagImgId);

  const syncFromSource = () => {
    if (sourceCode && targetCode) {
      targetCode.textContent = sourceCode.textContent.trim();
    }

    if (sourceSelector && targetSelector && sourceSelector.dataset.selectedIso) {
      targetSelector.dataset.selectedIso = sourceSelector.dataset.selectedIso;
    }

    if (sourceFlag && targetFlag) {
      const clonedFlag = sourceFlag.cloneNode(true);
      clonedFlag.id = targetFlag.id;
      targetFlag.replaceWith(clonedFlag);
    }
  };

  syncFromSource();
  initPhoneFlagSelector({
    selectorId: selectorId,
    modalId: modalId,
    flagImgId: flagImgId,
    codeId: codeId,
    commentSelector: '.form_hover_step2'
  });
  
  // Убеждаемся, что кнопка закрытия есть в заголовке для Step2 форм
  const phoneModal = document.getElementById(modalId);
  if (phoneModal) {
    ensureCloseButtonInHeader(phoneModal);
  }

  syncFromSource();
}

// Универсальная функция для обеспечения наличия кнопки закрытия во всех модальных окнах
function ensureAllCloseButtons() {
  const allPhoneModals = document.querySelectorAll('.phone_modal');
  allPhoneModals.forEach(modal => {
    ensureCloseButtonInHeader(modal);
  });
}

// Вызываем функцию после полной загрузки страницы
(function() {
  function _initCloseButtons() {
    setTimeout(() => { ensureAllCloseButtons(); }, 500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", _initCloseButtons);
  } else {
    _initCloseButtons();
  }
})();

// Экспортируем функции глобально
window.initPhoneFlagSelector = initPhoneFlagSelector;
window.initPhoneFlagSelectorStep2 = initPhoneFlagSelectorStep2;
window.ensureCloseButtonInHeader = ensureCloseButtonInHeader;
window.ensureAllCloseButtons = ensureAllCloseButtons;
window.ensurePhoneFlagEmojiElement = ensureEmojiFlagElement;
